
export interface RenameFolderSuccessfulResponse {
    jobId: string
}

export interface RenameFolderErrorResponse {
    message: string
    help: string
    reason: string
}

export enum JobStatus {
    INITIATED = 'INITIATED',
    PROCESSING = 'PROCESSING',
    PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
    SUCCESS = 'SUCCESS',
}

export interface StatusResponse {
    _id: string
    clientNumber: string
    userId?: string
    type?: string
    status: JobStatus
    purgeRequestId?: string
    message?: string
}

export interface UseBulkJobStatusOptions {
    bulkJobIds: string[]
    onData: (data: StatusResponse[]) => void
    initialDelay?: number
    maxDelay?: number
    factor?: number
    maxTotalTime?: number
}

export enum OperationStatus {
    INDETERMINATE = 'indeterminate',
    SUCCESS = 'success',
    ERROR = 'error',
    PENDING = 'pending',
    PARTIAL_SUCCESS = 'partial_success',
}

export interface BulkJobItem {
    name: string
    id: string
    jobId?: string
    status: OperationStatus
    errorMessage?: string
    type?: 'file' | 'folder'
}

export enum JobType {
    COPY = 'COPY',
    MOVE = 'MOVE',
    RENAME = 'RENAME',
}
export interface Job {
    id: string
    oldPath: string
    newPath: string
    jobType: string
    status?: string
    createdAt?: string
}

export interface JobSuccessfulResponse {
    _id: string
    clientNumber: string
    userId: string
    type: string
    status: OperationStatus
    purgeRequestId?: string
    message?: string
    createdAt?:string
    jobData: {
        sourceFolderPath?: string
        destinationPath?: string
        includeFileVersions?: boolean
        folderPath?: string
        purgeCache?: boolean
        newFolderName?: string

    }
}
export interface JobErrorResponse {
    message: string
    help: string
    reason: string
}
